{
  "pt": {
    "reminder": {
      "actions": {
        "cancel": "Cancelar",
        "edit": "Editar",
        "hideReminders": "Ocultar lembretes",
        "save": "Guardar",
        "showReminders": "Mostrar lembretes"
      },
      "contactType": {
        "customer": "Cliente",
        "partner": "Parceiro"
      },
      "labels": {
        "after": "após",
        "before": "antes de",
        "click": "Clique aqui para definir o lembrete",
        "date": "sobre {date}",
        "dateAfterDueDate": "Após a data de vencimento",
        "dateAlreadyPassed": "a data já passou",
        "decisionApprovedNotSent": "A decisão foi tomada. Os lembretes que ainda estavam na fila de espera são cancelados.",
        "dueDate": "a data de vencimento",
        "editTitle": "Editar lembretes",
        "here": "aqui",
        "infoReminders": "Os lembretes só estão activos para prestações com um prazo definido.",
        "noReminderSet": "Sem lembrete definido",
        "reminder": "Lembrete",
        "reminders": "Lembretes",
        "remindersCustomer": "Lembretes para o seu cliente",
        "remindersPartners": "Lembretes para o(s) parceiro(s)",
        "sendOnDeadline": "Será enviado um lembrete na data de vencimento",
        "sendReminder": "Enviar lembrete",
        "sent_at": "Lembrete enviado para {date}",
        "warningReminders": "Esta ação substitui todos os 4 lembretes. Qualquer lembrete deixado em branco aqui será removido para cada decisão."
      },
      "toasts": {
        "update": "Lembrete atualizado com sucesso"
      }
    }
  }
}